import { isDevelopment } from "../common/isDevelopment"

const LOCAL_REDIRECT_URL = "http://localhost:5173"

export const getAiAssistUrl = (projectName: string) =>
    isDevelopment ? LOCAL_REDIRECT_URL : `/aiassistant/${projectName}`
